import { all, fork } from "redux-saga/effects";

//public
import eventsSaga from "./events/saga";

export default function* rootSaga() {
  yield all([fork(eventsSaga)]);
}
